import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "booking-view catering" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["id", "checked", "onChange"]
const _hoisted_7 = ["for"]
const _hoisted_8 = {
  key: 0,
  class: "tags"
}
const _hoisted_9 = { class: "link" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "space-wrapper" }
const _hoisted_12 = { class: "modal details" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  class: "mobile-footer",
  hidden: ""
}
const _hoisted_17 = { class: "center-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("header", null, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelPagePensionStepHeadline']), 1),
          _createElementVNode("div", null, [
            (_ctx.pensionIndex === 0)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "back-btn",
                  title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                  to: { name: 'accommodation', query: _ctx.query }
                }, null, 8, ["title", "to"]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "back-btn",
                  title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeIndex(false)))
                }, null, 8, _hoisted_2)),
            (_ctx.pageTexts['hotelPagePensionStepInfoPopup'])
              ? (_openBlock(), _createBlock(_component_EasyDrop, {
                  key: 2,
                  dropdownType: 'tooltip',
                  position: 'right'
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "rte",
                      innerHTML: _ctx.pageTexts['hotelPagePensionStepInfoPopup']
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchBookingOverview.paxRooms, (paxRoom, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (index === _ctx.pensionIndex)
              ? (_openBlock(), _createElementBlock("fieldset", _hoisted_4, [
                  (_ctx.searchBookingOverview.paxRooms.length > 1)
                    ? (_openBlock(), _createElementBlock("legend", _hoisted_5, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageGeneralRoom']) + " " + _toDisplayString(index + 1) + ": " + _toDisplayString(_ctx.selectedRoom(paxRoom)?.name), 1),
                        _createTextVNode(" • " + _toDisplayString(paxRoom.searchRoom.adults.length) + " " + _toDisplayString(_ctx.adultSinglePlural(paxRoom.searchRoom.adults.length)), 1),
                        (paxRoom.searchRoom.children.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" • " + _toDisplayString(paxRoom.searchRoom.children.length) + " " + _toDisplayString(_ctx.childSinglePlural(paxRoom.searchRoom.children.length)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRoom(paxRoom)?.pensions, (pension, pensionOptionIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "option-icon",
                      key: pensionOptionIndex
                    }, [
                      _createElementVNode("input", {
                        id: 'pension' + index + pensionOptionIndex,
                        type: "checkbox",
                        name: "bookingPensions",
                        checked: pension.key === _ctx.searchBookingOverview.bookingSelection.hotelRooms[index].hotelPensionKey,
                        onChange: ($event: any) => (_ctx.updatePension($event, pension, index))
                      }, null, 40, _hoisted_6),
                      _createElementVNode("label", {
                        for: 'pension' + index + pensionOptionIndex
                      }, [
                        _createElementVNode("span", {
                          class: "label-content",
                          style: _normalizeStyle({ '--icon': 'url(' + pension.iconNotSelected + ')', '--icon-selected': 'url(' + pension.iconSelected + ')' })
                        }, [
                          _createElementVNode("span", null, [
                            _createElementVNode("strong", null, _toDisplayString(pension.name), 1),
                            _createElementVNode("small", null, _toDisplayString(pension.shortDescription), 1)
                          ])
                        ], 4),
                        (pension.price > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "+ " + _toDisplayString(pension.price.toLocaleString(_ctx.localeStrings.longName)) + " " + _toDisplayString(pension.currency), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_9, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.openModal($event, pension))
                          }, _toDisplayString(_ctx.pageTexts['hotelPagePensionStepLabelSeeDetails']), 9, _hoisted_10)
                        ])
                      ], 8, _hoisted_7)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.pensionIndex >= _ctx.searchBookingOverview.paxRooms.length - 1)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "btn-primary",
                to: { name: 'departure', query: _ctx.query }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIndex(true)))
              }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)),
          (_ctx.pensionIndex === 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                class: "prev",
                to: { name: 'accommodation', query: _ctx.query }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "prev",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeIndex(false)))
              }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1))
        ])
      ])
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showModal) = $event)),
      close: _ctx.closeModal,
      onBeforeEnter: _ctx.fixBody,
      onAfterLeave: _ctx.unfixBody
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_12, [
          _createElementVNode("header", null, [
            _createElementVNode("button", {
              class: "close-btn",
              title: _ctx.pageTexts['hotelPageGeneralModalButtonClose'],
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, null, 8, _hoisted_13),
            _createElementVNode("h2", null, _toDisplayString(_ctx.selectedPension?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "rte",
              innerHTML: _ctx.selectedPension?.description
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonBack']), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "close", "onBeforeEnter", "onAfterLeave"])
  ], 64))
}